import React, { memo } from 'react';
import pathRoutes from '../../../../../helper/pathRoutes';
import { useLocation, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Storage from '../../../../../helper/storage';
import { selectVerifyMailStatus, selectVerifySmsStatus, resetMfaStatus } from '../../../../../modules/myPoint/redux';
import { ReduxState } from '../../../../../redux/types';
import httpServices from '../../../../../core/http/apis';


function LinkHeader({ onCloseMenu }) {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    // メール認証、またはSMS認証のどちらかが成功しているかを取得
    const verifyMailStatus = useSelector(selectVerifyMailStatus);
    const verifySmsStatus = useSelector(selectVerifySmsStatus);
    const isMfaAuthenticated = verifyMailStatus === ReduxState.SUCCESS || verifySmsStatus === ReduxState.SUCCESS;

    const closeSpAccordionMenu = () => {

        // PC表示時は除外
        if (window.innerWidth >= 768) {
            return;
        }

        // 1. bodyタグの固定化クラスとインラインスタイルを解除します
        document.body.classList.remove('is-fixed');
        document.body.style.top = '';

        // 2. ハンバーガーボタン（js-sp-menu）のオープン状態クラスを外します
        const burgerBtn = document.querySelector('.js-sp-menu');
        if (burgerBtn) {
            burgerBtn.classList.remove('is-open');
        }

        // 3. 黒い画面の本体であるオーバーレイ要素の is-open クラスを外します
        const overlay = document.querySelector('.o-header-overlay');
        if (overlay) {
            overlay.classList.remove('is-open');
        }
    };

    const handleLinkClick = () => {
        // PC表示時は除外
        if (window.innerWidth >= 768) {
            return;
        }

        if (onCloseMenu) {
            onCloseMenu();
        }

        closeSpAccordionMenu();
    };

    // ★モニター情報確認・変更のクリックハンドラー
    const handleUserProfileClick = async (e) => {
        e.preventDefault(); // `<Link>` のデフォルト遷移も一度キャンセル

        try {
            // 1. サーバー側に「10分以内かどうか」だけをシンプルに確認する
            const res = await httpServices.get('/api/member/mfa/check-timeout');

            // PC表示時は除外
            if (window.innerWidth < 768) {
                closeSpAccordionMenu();
                if (onCloseMenu) {
                    onCloseMenu();
                }
            }

            if (isMfaAuthenticated && res && res.data?.isWithin10Minutes) {
                // 1-1. 10分以内の場合：認証状態を維持しているため、そのまま本来の確認画面へSPA遷移
                history.push(pathRoutes.userProfile);
            } else {
                // 1-2. 未認証（10分以上経過）の場合

                // ① Reduxの過去の認証ステータス（SUCCESS状態など）をきれいにリセット
                dispatch(resetMfaStatus());

                // ② メニュー導線の合図（from: 'profile'）を持ってMFA画面へ遷移
                history.push({
                    pathname: pathRoutes.mfa,
                    state: { from: 'profile' }
                });
            }
        } catch (error) {
            closeSpAccordionMenu();
            if (onCloseMenu) {
                onCloseMenu();
            }            
            // 通信エラーなどの安全ガード：基本は安全のためMFA画面へ飛ばす
            history.push({
                pathname: pathRoutes.mfa,
                state: { from: 'profile' }
            });
        }
    };

    return (
        <>
            {
                Storage.getAccessToken() ? (
                    <>
                        {/* 全ての <a> タグを `<Link to={...}>` に置き換え、フルリロードによるReduxの初期化を防ぎます */}
                        <Link to={pathRoutes.reports}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.reports ? 'is-current' : ''}`}
                        >アンケート結果</Link>
                        
                        <Link to={pathRoutes.pointAcquisition}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.pointAcquisition ? 'is-current' : ''}`}
                        >獲得ポイント履歴</Link>
                        
                        <Link to={pathRoutes.pointExchangeItem}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.pointExchangeItem ? 'is-current' : ''}`}
                        >ポイント交換 </Link>

                        {/* ★修正：クリックハンドラーを適用しつつ、安全な Link コンポーネントに変更 */}
                        <Link to={pathRoutes.userProfile}
                            onClick={handleUserProfileClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.userProfile ? 'is-current' : ''}`}
                        >モニター情報確認・変更</Link>

                        <Link to={pathRoutes.inquiry}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.inquiry ? 'is-current' : ''}`}
                        >お問い合わせ</Link>
                        {
                            window.innerWidth < 768 && (
                                <Link to={pathRoutes.closeAccount}
                                    onClick={handleLinkClick}
                                    className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.closeAccount ? 'is-current' : ''}`}
                                >退会</Link>
                            )
                        }
                    </>
                ) : (
                    <>
                        <Link to={pathRoutes.reports}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.reports ? 'is-current' : ''}`}
                        >アンケート結果</Link>
                        <Link to={pathRoutes.point}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.point ? 'is-current' : ''}`}
                        >ポイントについて</Link>
                        <Link to={pathRoutes.faq}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.faq ? 'is-current' : ''}`}
                        >よくある質問</Link>
                        <Link to={pathRoutes.inquiry}
                            onClick={handleLinkClick}
                            className={`o-header__body__link__item u-hover ${location?.pathname === pathRoutes.inquiry ? 'is-current' : ''}`}
                        >お問い合わせ</Link>
                    </>
                )
            }
        </>
    );
}

export default memo(LinkHeader);